"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is Range
 * @param obj The object to check
 */
function isRange(obj) {
    return safeInstanceOf_1.default(obj, 'Range');
}
exports.default = isRange;
//# sourceMappingURL=isRange.js.map